import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import { RouteKeys, ROUTES } from '../../constants/routes.constant';

export type FooterListItemProps = {
  title: string;
  href?: string;
  route?: RouteKeys;
  variant?: 'default' | 'referral' | 'events';
};

export const FooterListItem = ({ title, href, route, variant = 'default' }: FooterListItemProps) => {
  const isInternalLink = route ? true : false;
  const isLocalAnchor = href?.startsWith('#') || false;
  const link = isInternalLink ? ROUTES[route!] : href;
  const linkClasses =
    variant === 'referral' || variant === 'events'
      ? 'tw-text-white hover:tw-text-[#20AA67]'
      : 'tw-text-skyBlue hover:tw-text-turquoise';

  return (
    <li className={twMerge('tw-list-none tw-text-left tw-text-[16px] tw-font-medium tw-leading-[30px]')}>
      {isInternalLink || isLocalAnchor ? (
        <Link to={isLocalAnchor ? `/${href}` : link!} className={linkClasses}>
          {title}
        </Link>
      ) : (
        <a href={href!} target="_blank" rel="noopener noreferrer" className={linkClasses}>
          {title}
        </a>
      )}
    </li>
  );
};
